export const barStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '24px',
  padding: '14px 20px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const totalStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
};

export const labelStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const highlightValueStyles = {
  color: ({ palette }) => palette.primary.main,
};

export const liveStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginLeft: 'auto',
  color: ({ palette }) => palette.text.secondary,
};

export const liveDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: ({ palette }) => palette.success.main,
};
